import React, {useState, useEffect} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import jiraUtil from '../../components/jira/jira_util';
import {showModal, MODAL_TYPE} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import DirectApi from '../../directApi';

import {Button} from 'web-components';

const JiraIntegrationSection = ({company, project}) => {
	const intl = useIntl();

	const [jiraEpics, setJiraEpics] = useState(null);

	const retrieveLinkedEpics = epicIds => {
		if (!epicIds) return;
		DirectApi.FetchJson(`jira/issues?issueIds=${epicIds}`)
			.then(resp => resp.json())
			.then(epics => setJiraEpics(epics));
	};

	useEffect(() => {
		retrieveLinkedEpics(project.jiraCloudEpicIds);
	}, []);

	const handleUnlinkFromJira = () => {
		jiraUtil.unlinkProject(project);
	};

	const editJiraEpics = () => {
		showModal({
			type: MODAL_TYPE.JIRA_EDIT_EPICS,
			projectId: project.id,
			epicIds: project.jiraCloudEpicIds,
			retrieveLinkedEpics,
		});
	};

	const syncJiraProject = syncType => {
		showModal({
			type: MODAL_TYPE.SYNC_JIRA_PROJECT,
			jiraType: 'cloud',
			syncType,
			forecastProject: project,
			retrieveLinkedEpics,
		});
	};

	return (
		<div>
			{project.jiraCloudProject || project.jiraCloudEpicIds ? (
				<>
					{project.jiraCloudProject ? (
						<FormattedMessage
							id="settings.jira.linked_to_project"
							values={{name: <b>{project.jiraCloudProject.name}</b>}}
						/>
					) : (
						<FormattedMessage
							id="settings.jira.linked_to_epics"
							values={{
								name: (
									<b>
										{jiraEpics && jiraEpics.length > 0
											? jiraEpics.map(epic => epic.key).join(', ')
											: 'Loading...'}
									</b>
								),
							}}
						/>
					)}
					{project.jiraCloudEpicIds ? (
						<Button onClick={() => editJiraEpics()} variant={Button.VARIANT.GREEN_FILLED}>
							{intl.formatMessage({id: 'integrations.jira.edit_epics'})}
						</Button>
					) : (
						''
					)}
					<br />
					<Button onClick={() => handleUnlinkFromJira()} variant={Button.VARIANT.RED_OUTLINE}>
						{intl.formatMessage({id: 'settings.unlink_jira'})}
					</Button>
				</>
			) : (
				<>
					<Button onClick={() => syncJiraProject('project')} variant={Button.VARIANT.GREEN_FILLED}>
						{intl.formatMessage({id: 'integrations.jira.sync_to_jira_project'})}
					</Button>
					<br />
					<Button onClick={() => syncJiraProject('epics')} variant={Button.VARIANT.GREEN_FILLED}>
						{intl.formatMessage({id: 'integrations.jira.sync_to_jira_epics'})}
					</Button>
				</>
			)}
		</div>
	);
};

export default JiraIntegrationSection;
